import {useGSAP} from '@gsap/react'
import {QrCode} from '@repo/shared/QrCode'
import {useCopyToClipboard} from '@uidotdev/usehooks'
import gsap from 'gsap'
import {FC, useRef} from 'react'

interface IJoinCodeProps {
  url?: string
  code: number | null
}

const JoinCode: FC<IJoinCodeProps> = ({url, code}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [, copyToClipboard] = useCopyToClipboard()

  useGSAP(
    () => {
      if (!code) {
        return
      }

      const timeline = gsap.timeline()

      timeline.set('.animate', {scale: 0, rotate: 2})
      timeline.set(containerRef.current, {opacity: 1})

      timeline.to('.animate', {
        scale: 1,
        rotate: 0,
        duration: 0.5,
        stagger: 0.2,
        ease: 'back.out',
      })
    },
    {
      dependencies: [code],
    },
  )

  return (
    <div
      ref={containerRef}
      className="pointer-events-auto flex w-full max-w-[1096px] gap-4 opacity-0"
    >
      <div className="flex flex-1 flex-col gap-4" id="game-connect-info">
        {url && (
          <div
            className="animate truncate rounded-[32px] bg-white px-2 py-4 text-center text-[48px] font-semibold uppercase sm:text-[26px]"
            id="game-controller-url"
          >
            {/* TODO: animate this text somehow */}
            {url}
          </div>
        )}
        <div
          className="animate flex flex-1 items-center justify-center rounded-[32px] bg-white px-[48px] sm:px-[32px]"
          id="game-code"
        >
          <div
            className="-mr-[35px] flex h-full items-center justify-center text-center text-[156px] font-semibold uppercase leading-none tracking-[35px] sm:text-[108px]"
            onClick={() => {
              copyToClipboard(code ? code.toString() : '')
            }}
          >
            {code}
          </div>
        </div>
      </div>
      <div
        className="animate flex size-[312px] min-w-[312px] items-center justify-center rounded-[32px] bg-white p-[24px]"
        id="game-qr-container"
      >
        <QrCode url={url ?? ''} gameCode={code?.toString()} />
      </div>
    </div>
  )
}

export default JoinCode
